import React, { forwardRef } from 'react';
import { CFormSelect } from '@coreui/react';

// Simplified select component using CoreUI
const Select = forwardRef(({ 
  value,
  onChange,
  options,
  className,
  placeholder,
  disabled,
  ...props 
}, ref) => (
  <CFormSelect
    ref={ref}
    value={value}
    onChange={onChange}
    className={className}
    disabled={disabled}
    {...props}
  >
    {placeholder && (
      <option value="">{placeholder}</option>
    )}
    {options?.map((option) => (
      <option 
        key={option.value} 
        value={option.value}
        disabled={option.disabled}
      >
        {option.label}
      </option>
    ))}
  </CFormSelect>
));

Select.displayName = 'Select';

export { Select }; 